<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '未结清贷款明细'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :is-pagination-show="false"
      >
        <div slot="TableTop">
          <el-col :span="6"><div class="Htitle-text color-deep-blue">贷款余额合计：{{(balanceAmounts/10000).toFixed(2)||''}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">笔数合计：{{tableData.count}}</div></el-col>
        </div>
      </data-table>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "OutstandingToDateOldList",
    data(){
      return{
        applicationStatus: 'Pending Approval',
        roleData:{},
        dealerOptions:[],
        tableData: {
          count: 0,
          data: []
        },
        dealerTypeOptions:[],
        page: 1,
        pageSize: 20,
        actions: [
          {
            label: '导出',
            class: 'el-icon-download el-button--primary',
            clickHandler:()=>{
                if(this.filters.form.toDate===''){
                    this.$message.error('请填写日期')
                    return false
                }
              let routeData = this.$router.resolve({
                path: '/ix/fang/financing/reporting/OutstandingToDate.List?format=xls',
                query: Object.assign({
                  pageSize:0,
                  'toDate':this.filters.form.toDate,
                }, {
                  'xlist.sort.dataField': 'fi.startDate',
                  'xlist.sort.order': 'asc'
                }, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ],
        filters: {
          labelWidth: '150px',
          form: {
            fi__customerName:'',
            toDate:'',
            d__dealerId:'',
          },
          rules: {
            toDate:{
              required:true,
              message: '不能为空'
            }
          },
          columns: [
            {
              label: '日期',
              component: 'el-date-picker',
              field: 'toDate',
              op:'eq',
              valueFormat:'yyyy-MM-dd',
              span: 12,

            },
            {
              label: '渠道商',
              component: 'el-select',
              field: 'd__dealerId',
              options:[],
              span: 12
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'fi__customerName',

            },

          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          },
          onReset: ()=> {
            this.filters.form = {
              fi__customerName:'',
              toDate:'',
              d__dealerId:'',
            }
            this.tableData= {
              count: 0,
              data: []
            }
            this.totalAmounts = 0
            this.balanceAmounts = 0
          }
        },
        totalAmounts:0,
        balanceAmounts:0,
      }
    },
    computed:{
      columns: function(){
        return [
          {
            name:'序号',
            field: 'fi__index'
          },
            {
                label: '贷款编号',
                field: 'fi__transactionNo'
            },
          {
            label: '客户姓名',
            field: 'fi__customerName'
          },
           {
             label: '渠道商',
             field: 'd__dealerName'
           },


          {
            name: '贷款产品',
            field: 't__productName'
          },
          {
            name: '贷款本金',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return''
            }
          },
          {
            name: '贷款余额',
            field: 'fi__balanceAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '截止上一结息日未还利息',
            field: 'fi__overdueInterest',
            formatter: function (r,c,v) {
                if(v)
                    return formatMoney(v)
                else
                    return''
            }
          },
          {
            name: '贷款合同利率（%）',
            field: 'fi__interestRate'
          },
          {
            name: '开始日期',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },

          {
            name: '结束日期',
            field: 'fi__endDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            label: '期数',
            field: 'fi__repaymentCount'
          },
        ]
      },
      filterParams: {
        get: function() {
          return {

          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getData()
      },
    },

    mounted() {
      this.getDealerList()
    },
    methods: {
      getData: function () {
        xhr.getOutstandingToDateList(
          Object.assign({
            'toDate':this.filters.form.toDate,
            pageSize:0
          }, {
            'xlist.sort.dataField': 'fi.startDate',
            'xlist.sort.order': 'asc'
          }, xmlBuildQuery(this.filters)),
          res => {
            try {
              this.totalAmounts = 0
              this.balanceAmounts = 0
              this.tableData = res.data
              this.tableData.data.forEach(item=>{
                if(item.fi__totalAmount){
                  this.totalAmounts = this.totalAmounts +parseFloat(item.fi__totalAmount)*10000
                }
                if(item.fi__balanceAmount){
                  this.balanceAmounts = this.balanceAmounts +parseFloat(item.fi__balanceAmount)*10000
                }
              })
                this.tableData.data.push({
                    fi__customerName:'合计',
                    fi__balanceAmount:(this.balanceAmounts/10000).toFixed(2)||'',
                })

            } catch (e) {

            }
          })
      },
      getDealerList: function () {
        xhr.getDealerList(
          Object.assign({pageSize:0}, {}, {}),
          res=> {
          try {
            /*  this.filters.columns[1].options = [
              {
                label: '所有渠道商',
                value: ''
              }
            ].concat(res.data.data.map(item=>{
              return {
                label: item.d__dealerName,
                value:item.d__dealerId,
              }
            }))*/
            this.filters.columns[1].options = res.data.data.map(item=>{
              return {
                label: item.d__dealerName,
                value:item.d__dealerId,
              }
            })
            }catch(e){

            }
          })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/OutstandingToDateOldList.vue